import { Component, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { PromotionService } from '../../../shared/api/promotion.service';

/// One promise in the strip: the home page's "home.trust" fragment, an item each.
export interface FeatureItem {
    title: string;
    subtitle: string;
    url: string | null;
}

/// Which of the strip's icons suits a promise, by what it is about; the rest take them in turn.
const ICONS: { test: RegExp, icon: string }[] = [
    { test: /deliver|district|courier|ডেলিভারি|জেলা/i, icon: 'fi-free-delivery-48' },
    { test: /verif|seller|safe|secure|যাচাই|বিক্রেতা|নিরাপদ/i, icon: 'fi-payment-security-48' },
    { test: /support|whatsapp|help|সাহায্য|সহায়তা/i, icon: 'fi-24-hours-48' },
    // Two arrows round: what comes back. Not the tag - it says HOT, for offers only.
    { test: /return|refund|রিটার্ন|ফেরত/i, icon: 'updated' },
];
const IN_TURN = ['fi-payment-security-48', 'updated', 'fi-free-delivery-48', 'fi-24-hours-48'];

@Component({
    selector: 'app-block-features',
    templateUrl: './block-features.component.html',
    styleUrls: ['./block-features.component.scss']
})
export class BlockFeaturesComponent {
    @Input() layout: 'classic'|'boxed' = 'classic';
    /// The owner's promises (the "home.trust" fragment's items) in place of the four standard ones; none, the standard.
    @Input() items: FeatureItem[] = null;

    /// Free delivery over $200, up to $25 - read from the server, so the badge says what the
    /// checkout does.
    freeShipping$ = this.promotion.freeShipping$;

    constructor(public router:Router, private promotion: PromotionService, @Inject(DOCUMENT) private document: Document) { }

    icon(item: FeatureItem, index: number): string {
        const text = item.title + ' ' + item.subtitle;
        const match = ICONS.filter(rule => rule.test.test(text))[0];
        return match ? match.icon : IN_TURN[index % IN_TURN.length];
    }

    /// A promise with a link goes there: a page of the site in the app, anything else (WhatsApp) in a new tab.
    open(item: FeatureItem): void {
        if (!item.url) {
            return;
        }
        if (/^\/(?![\/\\])/.test(item.url)) {
            this.router.navigateByUrl(item.url);
        } else if (/^https?:\/\//i.test(item.url) && this.document.defaultView) {
            this.document.defaultView.open(item.url, '_blank', 'noopener');
        }
    }
}
